import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStats(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const event = parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(event, parsedResponse)
}

async function sendRequest() {
  const storeId = await self.servicesVars.getStoreId()
  const url = urls.proxyRequestSimultaneous
  const data = {
    storeId,
    requests: Object.keys(urls.stats).map(statKey => {
      return {
        method: 'get',
        id: statKey,
        url: urls.stats[statKey],
      }
    }),
  }
  const response = await Network.sendPostRequest(url, data)
  return response
}

function parseResponse(response) {
  if (response && response.status.code === 200) {
    const rawData = response.response
    const appData = Formatter.parseStatsResponse(rawData)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getStats }
